(function () {
    'use strict';

    angular.module('thankview.global')
        .directive('tvLazyLoader', ['$window', function ($window) {
            return {
                restrict: 'A',
                scope: true,
                link: function (scope, element, attrs) {
                    var isLoaded = function (img) {
                        img.className += ' loaded';
                    };
                    var setOnLoad = function () {
                        this.target.src = this.src;
                        isLoaded(this.target);
                    };

                    // If we don't have support for intersection observer, load the images immediately
                    if (typeof $window.IntersectionObserver === 'undefined') {
                        element[0].onload = function () {
                            isLoaded(element[0]);
                        };
                        attrs.$set('src', attrs.lazySrc);
                    } else {
                        var observer; // define the observer object
                        // It is supported, load the images
                        var config = {
                            // If the image gets within 250px in the Y axis, start the download.
                            rootMargin: '250px 0px',
                            threshold: 0.01,
                        };
                        var loadImg = function (changes) {
                            for (var i = 0; i < changes.length; i++) {
                                // if element is not inside a hidden element, and is in the viewport, load it
                                if (changes[i].target.offsetParent !== null && changes[i].intersectionRatio > 0) {
                                    var img = new $window.Image();
                                    var target = changes[i].target;
                                    var bindObj = { target: target, src: attrs.lazySrc };
                                    img.onload = setOnLoad.bind(bindObj);
                                    img.src = attrs.lazySrc;
                                    // stop observing
                                    observer.unobserve(changes[i].target);
                                }
                            }
                        };
                        observer = new $window.IntersectionObserver(loadImg, config);
                        observer.observe(element[0]);
                    }
                },
            };
        }]);
}());
